import { ref, watch } from 'vue'
import type { Ref } from 'vue'

/**
 * Ref, синхронизированный с localStorage. Аналог `useLocalStorage` из vueuse,
 * но без зависимости: в проекте уже есть свои `useCookie` и `useScrollLock`.
 * Битое значение молча заменяется дефолтом — падать из-за хранилища незачем.
 */
export function useLocalStorage<T>(key: string, fallback: T): Ref<T> {
  const read = (): T => {
    try {
      const raw = localStorage.getItem(key)
      return raw === null ? fallback : (JSON.parse(raw) as T)
    } catch {
      return fallback
    }
  }

  const state = ref(read()) as Ref<T>

  watch(
    state,
    (value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value))
      } catch {
        /* приватный режим или переполненное хранилище — работаем в памяти */
      }
    },
    { deep: true },
  )

  return state
}
